// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c29d9e52","513":"f8cc8af0","703":"5f8bb1e5"}[chunkId] + ".chunk.js";
};